import type { IBrandConfig } from './types';

const DMINOR_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: {
    kind: 'external',
    url: 'https://www.pango.co/privacy-policy',
  },
  termsOfService: { kind: 'cms', path: 'policy/tou/minor-defense-terms.md' },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  licensor: 'cyex',
  enrollmentFaqRequiredInfo: 'activationCodeAndContact',
  vaultProject: 'minor_defense',
  adaChat: true,
  defaultBillingCategoryKey: 'identityguard_fi',
  copyRightEntity: 'CyEx, LLC',
  hasCustomerServiceSupport: true,
  headerPhone: true,
  carouselBanners: true,
  security: true,
  finishSetup: true,
  secureUpload: true,
  accountDetails: true,
  dwEmailVerification: {
    adaChat: true,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday – Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      availability: (
        <>
          Monday – Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
  // Child-only plan: Angular shows only the child family-plan questions
  faqOverrides: {
    hiddenQuestions: [
      'familyPlanFaqs.addAdult',
      'familyPlanFaqs.howManyAdults',
      'familyPlanFaqs.howManyAdultsCapped',
      'familyPlanFaqs.adultsCanAddChildren',
    ],
  },
};

export default DMINOR_BRAND_CONFIG;
